import script from "./RecommendedCourses.vue?vue&type=script&setup=true&lang=js"
export * from "./RecommendedCourses.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__